import { Component, Input } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IndividualRelationshipGroupModel } from "../../models/individual-relationship-group-model";
import { Contact } from "@models/common/contact";

type CellRendererParams = ICellRendererParams<IndividualRelationshipGroupModel>;

interface IconData {
  icon: string;
  data: string;
}

@Component({
  selector: 'app-ag-individual-contact',
  standalone: true,
  templateUrl: 'ag-individual-contact.component.html',
})
export class AgIndividualContactComponent implements ICellRendererAngularComp {
  @Input() contact: Contact | undefined = undefined;
  @Input() contacts: Contact[] = [];

  elements: IconData[] = [];
  contactsElements: (IconData | string)[] = [];

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.contacts = [];
    this.contactsElements = [];

    if (params.data) {
      this.contacts.push(...params.data.contacts);
    }

    if (this.contacts.length == 1) {
      this.contactsElements.push(...this.contactToContactElements(this.contacts[0]));
    } else {
      this.contacts.forEach((contact: Contact) => {
        this.contactsElements.push(contact.nickname);
        this.contactsElements.push(...this.contactToContactElements(contact));
      });
    }

    return true;
  }

  contactToContactElements(contact: Contact): IconData[] {
    const map: Record<string, string> = {
      'ic-mail-16': contact?.email ?? '',
      'ic-phone-16': contact?.phone ?? '',
      'ic-registered-agent-ceasing-16': contact?.nickname ?? '',
    };

    // build an array of only the entries that have a value
    return Object.entries(map)
      .filter(([, val]) => Boolean(val))
      .map(([icon, val]) => ({ icon, data: val }));
  }
}
